var Model = require("../types/Model.js");

/**
 * Counts the number of users in a manage Group.
 * @type {Model}
 */
module.exports = Model({
	name: "manageduserscount",
	init: init,
	uninit: uninit,
	listeners: listeners,

	_group: null,
	refresh: refresh,
	handle_managedusers_updated: handle_managedusers_updated,
});

function init() {

	this._users_count = 0;
	this._query = null;
	this._group = null;
	this.refresh();

	this.push();
}

/** //
 * Clears extra data
 * @return {Promise} Resolves after everything is done.
 */
function uninit() {
	this._query = null;
	this._group = null;
	this._users_count = 0;
}

function listeners() {
	return {
		"connectivity:online": refresh,
		"activemanagegroup:updated": update_active_group
	};
}

function update_active_group(group) {
	this._group = group;
	this.handle_managedusers_updated(group);

}

function refresh() {
	return this.api.manage.count(this._group)
		.then(total_users.bind(this));
}

function handle_managedusers_updated(group) {
	return this.api.manage.count(group)
		.then(total_users.bind(this));
}

function total_users(count) {
	this._users_count = count;
	this.push(count);
}
